import React from 'react';
import { X, Download, ExternalLink } from 'lucide-react';

interface AttachmentViewerProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'image' | 'file';
  url: string;
  title?: string;
}

function AttachmentViewer({ isOpen, onClose, type, url, title }: AttachmentViewerProps) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div className="absolute top-4 right-4 z-50">
        <button
          onClick={onClose}
          className="p-2 bg-black bg-opacity-50 rounded-full text-white hover:bg-opacity-75 transition-opacity"
        >
          <X className="h-6 w-6" />
        </button>
      </div>

      {type === 'image' ? (
        <img
          src={url}
          alt={title || 'Full size image'}
          className="max-w-full max-h-[90vh] object-contain"
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <div 
          className="bg-white rounded-lg p-6 max-w-lg w-full text-center"
          onClick={(e) => e.stopPropagation()}
        >
          <h3 className="text-xl font-semibold mb-4">{title || 'View File'}</h3>
          <div className="space-y-4">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
              <ExternalLink className="h-5 w-5" />
              Open in New Tab
            </a>
            <a
              href={url}
              download
              className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <Download className="h-5 w-5" />
              Download
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default AttachmentViewer;